"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.flattenCategoryList = exports.filterDeletedCategory = exports.CATEGORIES_CONFIG = void 0;
exports.getCategoryPermissionModel = getCategoryPermissionModel;
exports.getCategoryType = getCategoryType;
exports.getCollapsableCategories = getCollapsableCategories;
exports.getEditCategoryUrl = void 0;
exports.normalizePermissions = normalizePermissions;
exports.toggleCollapseAllCategories = toggleCollapseAllCategories;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _constants = require("./constants");

var _categories = require("@insided/shared/utils/categories");

var _CATEGORIES_CONFIG;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var filterDeletedCategory = function filterDeletedCategory(categories, id) {
  return categories.filter(function (category) {
    if (category.id === id) {
      return false;
    }

    if (category.children.length > 0) {
      category.children = filterDeletedCategory(category.children, id);
    }

    return true;
  });
};

exports.filterDeletedCategory = filterDeletedCategory;

function toggleCollapseAllCategories(categories, collapse) {
  return categories.map(function (oldCategory) {
    var category = _objectSpread({}, oldCategory);

    category.isCollapsed = collapse;
    return category;
  });
}

function getCategoryType(isContainer) {
  if (!isContainer) return _constants.CATEGORY_SECTION_TYPE.Category;
  return _constants.CATEGORY_SECTION_TYPE.Section;
}

function getCollapsableCategories(categories) {
  return categories.map(function (category) {
    var collapsableCategory = _objectSpread({}, category);

    if (collapsableCategory.isContainer) {
      collapsableCategory.isCollapsed = false;
      collapsableCategory.children = getCollapsableCategories(category.children);
    }

    return collapsableCategory;
  });
}

var normalizeRoles = function normalizeRoles(roles, isMain) {
  return roles.map(function (role) {
    var _role$isMain;

    return {
      title: role.title,
      role: role.role,
      visibility: role.visibility,
      create_topics: role.create_topics,
      create_posts: role.create_posts,
      isMain: (_role$isMain = role.isMain) !== null && _role$isMain !== void 0 ? _role$isMain : isMain
    };
  });
};

function normalizePermissions(accessRoles) {
  var main = accessRoles.main,
      custom = accessRoles.custom;
  var permissions = [];
  permissions.push.apply(permissions, (0, _toConsumableArray2.default)(normalizeRoles(main, true)));
  permissions.push.apply(permissions, (0, _toConsumableArray2.default)(normalizeRoles(custom, false)));
  return permissions;
}

function getCategoryPermissionModel(model) {
  return [{
    header: "".concat(model, " role"),
    accessor: 'title'
  }, {
    header: 'Category Visibility',
    accessor: 'view'
  }, {
    header: 'Create Topics',
    accessor: 'createTopic'
  }, {
    header: 'Create Replies',
    accessor: 'createReply'
  }];
}

var getEditCategoryUrl = function getEditCategoryUrl(categorySectionType, id, moduleName) {
  return "/platform/".concat(moduleName, "/edit?id=").concat(id, "&categorySectionType=").concat(categorySectionType);
};

exports.getEditCategoryUrl = getEditCategoryUrl;

var flattenCategoryList = function flattenCategoryList(categories) {
  var flatCategoryList = [];
  categories.forEach(function (category) {
    flatCategoryList.push({
      id: category.id,
      name: category.title,
      isContainer: category.isContainer
    });

    if (category.children.length > 0) {
      flatCategoryList.push.apply(flatCategoryList, (0, _toConsumableArray2.default)(flattenCategoryList(category.children)));
    }
  });
  return flatCategoryList;
};

exports.flattenCategoryList = flattenCategoryList;
var CATEGORIES_CONFIG = (_CATEGORIES_CONFIG = {}, (0, _defineProperty2.default)(_CATEGORIES_CONFIG, _categories.MODULE.KNOWLEDGE_BASE, {
  showIncludeForStats: true,
  showHeroImage: true,
  showThumbnailImage: true,
  showHideFromSearch: true,
  showMetaRobots: true,
  showCuratedContent: false,
  showOrderTopicsOverview: true,
  showSupportedContentTypes: false
}), (0, _defineProperty2.default)(_CATEGORIES_CONFIG, _categories.MODULE.COMMUNITY, {
  showIncludeForStats: true,
  showHeroImage: true,
  showThumbnailImage: true,
  showHideFromSearch: true,
  showMetaRobots: true,
  showCuratedContent: true,
  showOrderTopicsOverview: false,
  showSupportedContentTypes: true
}), (0, _defineProperty2.default)(_CATEGORIES_CONFIG, _categories.MODULE.IDEATION, {
  showIncludeForStats: false,
  showHeroImage: false,
  showThumbnailImage: false,
  showHideFromSearch: false,
  showMetaRobots: false,
  showCuratedContent: false,
  showOrderTopicsOverview: false,
  showSupportedContentTypes: false
}), (0, _defineProperty2.default)(_CATEGORIES_CONFIG, _categories.MODULE.PRODUCT_UPDATES, {
  showIncludeForStats: false,
  showHeroImage: false,
  showThumbnailImage: false,
  showHideFromSearch: false,
  showMetaRobots: false,
  showCuratedContent: false,
  showOrderTopicsOverview: false,
  showSupportedContentTypes: false
}), (0, _defineProperty2.default)(_CATEGORIES_CONFIG, _categories.MODULE.GROUPS, {
  showIncludeForStats: false,
  showHeroImage: false,
  showThumbnailImage: false,
  showHideFromSearch: false,
  showMetaRobots: false,
  showCuratedContent: false,
  showOrderTopicsOverview: false,
  showSupportedContentTypes: false
}), _CATEGORIES_CONFIG);
exports.CATEGORIES_CONFIG = CATEGORIES_CONFIG;